import { useNavigate } from "react-router";

export const KnowMoreButton = ({ text = "Know More", href }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        if (href) navigate(href);
      }}
      class="contact-btn"
    >
      {text}
    </button>
  );
};
